export function waitForSocketConnection(socket: any, callback: any, iteration: number = 0) {
	if (socket.readyState === 1) {
		if (callback != null) {
			callback(socket);
		}
	} else if (iteration < 100) {
		setTimeout(function () {
			console.log('wait for connection...');
			waitForSocketConnection(socket, callback, iteration++);
		}, 200);
	}
}
